import { render } from "./GatewayBulkUpload.vue?vue&type=template&id=02521095"
import script from "./GatewayBulkUpload.vue?vue&type=script&lang=js"
export * from "./GatewayBulkUpload.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__